import createSvgIcon from '@material-ui/core/utils/createSvgIcon';

const Glossary = createSvgIcon(
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    fill="currentColor"
  >
    <path d="M12.4444 0.5H2.33333C1.39533 0.5 0 1.17915 0 3.05V14.95C0 16.8209 1.39533 17.5 2.33333 17.5H14V15.8H2.34267C1.98333 15.7898 1.55556 15.6351 1.55556 14.95C1.55556 14.8642 1.56256 14.7877 1.57422 14.7179C1.66133 14.2283 2.02844 14.1085 2.34267 14.1H14V2.2C14 1.74913 13.8361 1.31673 13.5444 0.997918C13.2527 0.679107 12.857 0.5 12.4444 0.5ZM12.4444 8.15L10.8889 7.3L9.33333 8.15V2.2H12.4444V8.15Z" />
  </svg>,
  'Glossary'
);

export default Glossary;
